import Vue from "vue";
import router from "./router/index.js";
import store from "./store/index.js";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import * as VueGoogleMaps from "vue2-google-maps";
import { shuffle } from "./helpers/functions.js";
import config from "./config.js";

Vue.config.productionTip = false;
Vue.config.devtools = true;

let loadSchools = async () => {
  return await axios.get("/api/v1/schools");
};

let loadCategories = async () => {
  return await axios.get("/api/v1/categories");
};

const loadTranslate = () => {
  // If the google-translate script hasn't been added then create it
  if (!document.getElementById("google-translate")) {
    const scriptTag = document.createElement("script");
    scriptTag.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    scriptTag.id = "google-translate";
    scriptTag.async = false;
    // Append it to the document head
    document.getElementsByTagName("head")[0].appendChild(scriptTag);
  }
  loadTranslateObserver();
};

const loadTranslateObserver = () => {
  // Get the main html tag
  const html = document.getElementById("mainHTML");
  // Watch for mutations of the html tag's attributes
  const observer = new MutationObserver(function (mutations) {
    mutations.map((mutation) => {
      // When mutation type is attributes
      if (mutation.type === "attributes") {
        // Set the language state in the store to the lang nodeValue
        store.commit("setLanguage", mutation.target.attributes.lang.nodeValue);
        // Set the translate dropdown state in the store to false
        // so it closes when there is a change in the lang attribute
        store.commit("toggleTranslateDropdown", false);
      }
    });

    // This helps tell the modals when the translate bar is showing so their styles can reflect that
    // Get number of elements with skiptranslate class
    const numberOfSkipTranslateElements = document.querySelectorAll(
      "#mainHTML .skiptranslate"
    ).length;

    // Get the main body element
    const body = document.getElementById("mainBody");
    // Get the computedStyle of the first child of the main body with class skiptranslate
    const skipTranslateElement = body.getElementsByClassName("skiptranslate")[0];
    const computedStyle = window.getComputedStyle(skipTranslateElement);
    numberOfSkipTranslateElements === 6 && computedStyle.getPropertyValue("display") === "block"
      ? store.commit("toggleTranslateBar", true)
      : computedStyle.getPropertyValue("display") === ("none" || "")
      ? store.commit("toggleTranslateBar", false)
      : null;
  });

  // Tell the MutationObserver to observe the lang attribute
  observer.observe(html, {
    attributes: true,
    attributeFilter: ["lang"],
  });
};

const setApiUrl = () => {
  switch (window.location.hostname) {
    case "dev-choosemesa.mpsaz.org":
      axios.defaults.baseURL = "https://dev-choosemesa-admin.mpsaz.org";
      // console.log("baseURL set to", axios.defaults.baseURL);
      break;
    case "staging-choosemesa.mpsaz.org":
      axios.defaults.baseURL = "https://staging-choosemesa-admin.mpsaz.org";
      console.log("baseURL set to", axios.defaults.baseURL);
      break;
    case "choosemesa.mpsaz.org" || "choosemesa.org":
      axios.defaults.baseURL = "https://choosemesa-admin.mpsaz.org";
      break;
      default:
        if ("baseURL" in config) {
        axios.defaults.baseURL = config.baseURL;
        // console.log("baseURL set to", config.baseURL);
      } else {
        // console.log("baseURL does not exist for", window.location.hostname);
        throw new Error("baseURL does not exist for", window.location.hostname);
      }
      break;
    }
  };

Vue.use(VueAxios, axios);

axios.defaults.timeout = 120000;
let retries = 15;

Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleAPIKey,
    libraries: "places,geometry",
  },
});

const errDiv = document.createElement("div");
const contactDiv = document.createElement("div");
errDiv.className = "text-center";
const loadFunction = async () =>
  Vue.$gmapApiPromiseLazy()
    .then(() => {
      setApiUrl();
      retries--;
      axios.all([loadSchools(), loadCategories()]).then(
        axios.spread(function (schools, categories) {
          store.commit("toggleLoading", false);
          store.state.search.categories = categories.data;
          //convert polygons data object to array for gmaps, api will not return as array for some reason
          store.state.main.schools = schools.data
            .filter((e) => e && Object.keys(e).length > 0)
            .map(function (e) {
              let paths = Object.keys(e.polygons).map(function (key) {
                parseFloat(e.polygons[key].latitude);
                parseFloat(e.polygons[key].longitude);
                return e.polygons[key];
              });
              e.preschool = e.types.includes("preschool") ? 1 : 0;
              e.elementary = e.types.includes("elementary") ? 1 : 0;
              e.junior_high = e.types.includes("jr_high") ? 1 : 0;
              e.high_school = e.types.includes("high_school") ? 1 : 0;
              e.choice_school = e.types.includes("choice") ? 1 : 0;
              e.active = e.is_active;
              e.latitude = parseFloat(e.latitude);
              e.longitude = parseFloat(e.longitude);
              e.polygons = paths;
              e.selected = false; // for compare feature
              e.disabled = false; // for compare feature
              e.showInfoWindow = false; // for locator map
              e.showPolygons = false; // for locator map
              e.showMapMarker = false; // for locator map
              e.distance = ""; // for address filter on sidebar
              e.imagesPath = axios.defaults.baseURL + "/storage/" + e.imagesPath;
              return e;
            });
          store.state.main.schools = store.state.main.schools.filter(
            (school) => school.active === 1
          );
          store.state.main.filteredSchools = {
            normal: shuffle(store.state.main.schools),
            choice: [],
            results: store.state.main.schools.length,
          };
          store.state.search.categories.forEach((c) => {
            c.features.forEach((f) => {
              Vue.set(store.state.search.filters.features, f.name, false);
            });
          });
          store.state.search.geocoder = new google.maps.Geocoder();
          store.state.search.polygon = new google.maps.Polygon();
        })
      );
    })
    .then(() => {
      store.commit("toggleLoading", true);
      clearInterval(interval);
      new Vue({
        store,
        router,
        created() {
          loadTranslate();
          store.watch(
            (state) => state.main.filteredSchools,
            (newValue, oldValue) => {
              this.$root.$emit("toggleCardDefault");
            }
          );
        },
        render: (h) => h(App),
      }).$mount("#app");
    })
    .catch((err) => {
      if (retries <= 0) {
        const a = document.createElement("a");
        a.href = "mailto:web@mpsaz.org";
        a.textContent = "web@mpsaz.org";
        a.style.setProperty("color", "gold");
        a.addEventListener("mouseover", (ev) => {
          ev.target.style.setProperty("color", "coral");
        });
        a.addEventListener("mouseout", (ev) => {
          ev.target.style.setProperty("color", "gold");
        });
        const loadingH1 = document.getElementById("loadingH1");
        loadingH1.textContent = "Something is wrong...";
        contactDiv.textContent = "Please contact MPS Web Services at - ";
        contactDiv.append(a);
        errDiv.append(contactDiv);
        const loadDiv = document.getElementById("loading");
        loadDiv.append(errDiv);
      }
    });

const interval = setInterval(() => {
  loadFunction();
}, 10000);

loadFunction();
